module.exports = __webpack_public_path__ + "static/leopardorganicmuslin-dd4b04ab0668fbcd1b735487887eef74.jpeg";